
import OceanProtocol from "../../../assets/outline/OceanProtocol.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function OceanProtocolIcon({ className, dataTestid = "OceanProtocolIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <OceanProtocol data-testid={dataTestid} className={classes} {...rest} />
  );
}
